"use client";

import { FormEvent, useEffect, useState } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { marketSearchHref, isMarketplaceActive } from "@/lib/layout/site-nav";

export default function DesktopHeaderSearch() {
  const router = useRouter();
  const pathname = usePathname() ?? "/";
  const searchParams = useSearchParams();
  const [query, setQuery] = useState("");

  useEffect(() => {
    const fromUrl = isMarketplaceActive(pathname)
      ? (searchParams.get("search") ?? "")
      : "";
    const timer = window.setTimeout(() => setQuery(fromUrl), 0);
    return () => window.clearTimeout(timer);
  }, [pathname, searchParams]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const href = marketSearchHref(pathname, searchParams.toString(), query);
    if (!href) return;
    router.push(href);
  };

  return (
    <form onSubmit={handleSubmit} className="min-w-0 flex-1" role="search">
      <label htmlFor="desktop-header-search" className="sr-only">
        Search items
      </label>
      <div className="relative">
        <MagnifyingGlassIcon
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-text-light"
          aria-hidden="true"
        />
        <input
          id="desktop-header-search"
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search items"
          className="w-full rounded-md border border-border bg-surface py-2 pl-9 pr-3 text-sm text-foreground placeholder:text-text-light focus:outline-none focus:ring-2 focus:ring-primary"
        />
      </div>
    </form>
  );
}
